const WebsiteIcon = ({ className = '' }: { className?: string }) => (
	<svg
		className={className}
		width='20'
		height='20'
		viewBox='0 0 24 24'
		fill='none'
		stroke='#F2994A'
		strokeWidth='2'
		strokeLinecap='round'
		strokeLinejoin='round'
	>
		<circle cx='12' cy='12' r='10' />
		<line x1='2' y1='12' x2='22' y2='12' />
		<path d='M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z' />
	</svg>
);

export default WebsiteIcon;
